import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsYamahacorporationComponent } from './simple-icons-yamahacorporation.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsYamahacorporationComponent ],
    exports:      [ SimpleIconsYamahacorporationComponent ],
    bootstrap:    []
})
export class SimpleIconsYamahacorporationModule {}
